import { getParentByTag } from "../Helper/helper";

export let StoreFilter = {
  /**
   * Init store filters
   */
  initFilters: function () {
    const that = this;
    const mbFilters = document.querySelectorAll(".mb-floorplan-single-filter");

    for (let i = 0; i < mbFilters.length; i++) {
      mbFilters[i].addEventListener("click", function (event) {
        let listItem = event.target;
  
        if (listItem.closest("ul").classList.contains("open")) {
          that.filterStores(event.target);
          listItem.closest("ul").prepend(listItem);
        }
  
        listItem.closest("ul").classList.toggle("open");
      });
    }
  },

  /**
   * filter stores via ajax
   * @param {dom} target
   */
  filterStores: function (target) {
    const that = this;
    const categories = target.dataset.categories;
    let storeList = window.FloorplanView.container.querySelector(
      ".mb-floorplan-store-list-mobile-label"
    );

    // Hide mobile storelist before change filters
    that.showHideResponsiveStoreSelect(storeList, "false");
    storeList.classList.add("loading");

    jQuery.ajax({
      url: mb_plugin_globalvars.ajaxurl,
      type: "POST",
      data: {
        action: "ajax_handle_filter_stores",
        categories: categories,
      },
      success: function (response) {
        //do something on success
        const storeListContainer = document.getElementById(
          "mb-floorplan-store-list-container"
        );

        storeListContainer.innerHTML = response.data;

        const allFilters = document.getElementsByClassName(
          "mb-floorplan-single-filter"
        );
        for (let i = 0; i < allFilters.length; i++) {
          allFilters[i].classList.remove("active");
        }

        target.classList.add("active");

        // Show mobile storelist on change filters
        storeList = storeListContainer.querySelector(
          ".mb-floorplan-store-list-mobile-label"
        );
        storeList.classList.remove("loading");
        that.showHideResponsiveStoreSelect(storeList, "true");
      },
      error: function (xhr) {
        //do something on error
        console.log("Error", xhr.responseText);
      },
    });
  },

  /**
   * Init responsive store filter select
   */
  initResponsiveStoreFilterSelect() {
    const that = this;
    document.addEventListener(
      "click",
      function (event) {
        if (event.target.hasAttribute("aria-expanded")) {
          // Open / Close submenus
          if (event.target.getAttribute("aria-expanded") == "true") {
            // Open expendable childs
            that.showHideResponsiveStoreSelect(event.target, "false");
          } else {
            // close siblings
            const parentMenu = getParentByTag(event.target, "li");

            if (parentMenu) {
              const siblingMenus = parentMenu.parentNode.querySelectorAll(
                "li > ul > [aria-expanded]"
              );

              for (let i = 0; i < siblingMenus.length; i++) {
                if (siblingMenus[i] != event.target) {
                  that.showHideResponsiveStoreSelect(siblingMenus[i], "false");
                }
              }
            }

            // Close expendable childs
            that.showHideResponsiveStoreSelect(event.target, "true");
          }
        }
      },
      false
    );
  },
  showHideResponsiveStoreSelect(menuitem, expanded) {
    if (!menuitem || !expanded) return;

    const childMenus = menuitem.parentNode.querySelectorAll(
      ":scope > [aria-hidden]"
    );

    if (expanded == "true") {
      // Open expendable childs
      menuitem.setAttribute("aria-expanded", "true");
      for (let j = 0; j < childMenus.length; j++) {
        childMenus[j].setAttribute("aria-hidden", "false");
      }
    } else {
      // Close expendable childs
      menuitem.setAttribute("aria-expanded", "false");
      for (let j = 0; j < childMenus.length; j++) {
        childMenus[j].setAttribute("aria-hidden", "true");
      }
    }
  },
};
